module.exports = __webpack_public_path__ + "static/media/logo.eb79637b.png";